import { List, Skeleton } from '@mui/material'
import { FC, useMemo } from 'react'
import useInfiniteScroll from 'react-infinite-scroll-hook'
import { useLocation, useNavigate } from 'react-router-dom'
import { ThreadShortDTO } from '../../../../api/gen/base'
import { useInfiniteThreadListQuery } from '../../../../api/hooks/useInfiniteThreadListQuery'
import { REQUESTS_ROUTE } from '../../../../constants/routing.constants'
import { NavigationButton } from './NavigationButton'
import { RequestNavigationButton } from './RequestNavigationButton'
import { SidebarDivider } from './SidebarDivider'

export const RequestsList: FC = () => {
    const navigate = useNavigate()
    const { pathname } = useLocation()

    const { data, fetchNextPage, hasNextPage, isFetching } = useInfiniteThreadListQuery({
        is_archived: false,
    })

    const requestsList = useMemo(
        () =>
            data?.pages.reduce<ThreadShortDTO[]>((acc, page) => acc.concat(page.objects), []) ?? [],
        [data],
    )

    const [infiniteRef] = useInfiniteScroll({
        loading: isFetching,
        hasNextPage,
        onLoadMore: fetchNextPage,
    })

    const handleOpenRequestsListPage = () => {
        navigate(`${REQUESTS_ROUTE}?is_archived=false`)
    }

    if (!requestsList.length) {
        return null
    }

    return (
        <>
            <SidebarDivider />
            <List sx={{ p: '0 16px', position: 'relative' }}>
                <NavigationButton
                    onClick={handleOpenRequestsListPage}
                    textColor="#5A5F72"
                    isActive={pathname === REQUESTS_ROUTE}>
                    Запросы
                </NavigationButton>
                {requestsList.map((request) => (
                    <RequestNavigationButton key={request.id} request={request} />
                ))}
                {hasNextPage && (
                    <Skeleton
                        ref={infiniteRef}
                        variant="rectangular"
                        width="100%"
                        height={30}
                        sx={{
                            borderRadius: '22px',
                            minHeight: '30px',
                        }}
                    />
                )}
            </List>
        </>
    )
}
